import React from 'react'
import L from 'react-loadable'

const Loading = () => (
    <div style={{height:'100vh'}}>Loading...</div>
)

export default opts => L({
    loading: Loading,
    ...opts
})


// WEBPACK FOOTER //
// ./src/features/ui/components/Loadable.js